<template>
  <div>
     <!-- The video -->
    <Video ref="vid" :src="'http://assets.keepyou.fit/fitness/' + this.config.group + '/' + this.config.file"  :poster="'http://assets.keepyou.fit/fitness/' + this.config.group + '/' + this.config.prev">
    </Video>

    <!-- Optional: some overlay text to describe the video -->
    <div class="workout-top-left">
      <p class="is-size-3">{{ config.name }}</p>
    </div>

    <div class="workout-mitte">
      <img v-show=" ! run && ! end" @click="start" src="/../../static/svg/play-primary.svg" style="width:4rem;" />
      <img v-show="end" @click="start" src="/../../static/svg/load-primary.svg" style="width:4rem;" />
    </div>

    <div @click="skip" class="workout-bottom has-text-centered m-b-lg">
      <p v-show=" ! end" class="is-size-4">{{ $t('Skip') }}</p>
      <button v-show="end" class="button has-background-primary has-text-white is-size-4 is-rounded p-l-xl p-r-xl">{{ $t('Begin') }}</button>
    </div>

    <div class="workout-top-right">
      <img @click="menu" src="@/../static/svg/cancel.svg" class="is-medium icon" style="opacity:0.5;">
    </div>
  </div>
</template>

<script>
import Video from '@/components/Settings/VideoM'

export default {
  name: 'Showcase',
  props: ['config'],
  data () {
    return {
      run: false,
      end: false,
      timeout: undefined
    }
  },
  methods: {
    start () {
      this.run = true
      this.end = false
      this.$refs.vid.play()
      this.timeout = setTimeout(this.showEnd, 3000)
    },
    stop () {
      this.run = false
      this.$refs.vid.stop()
    },
    menu () {
      this.$refs.vid.pause()
      if (this.timeout !== undefined) clearTimeout(this.timeout)
      this.$emit('menu')
    },
    skip () {
      this.run = false
      this.$refs.vid.pause()
      if (this.timeout !== undefined) clearTimeout(this.timeout)
      this.$emit('end')
    },
    showEnd () {
      this.run = false
      this.end = true
      this.$refs.vid.stop()
    }
  },
  components: {
    Video
  }
}
</script>

<style>
.workout-top-left {
  position: fixed;
  top: 1rem;
  left: 1rem;
}
.workout-top-right {
  position: fixed;
  top: 1rem;
  right: 1rem;
}
.workout-bottom {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
}
.workout-mitte {
  position: fixed;
  top: 50%;
  left: 50%;
  margin-left: -2rem;
  margin-top: -2rem;
  width: 4rem;
}
</style>





// WEBPACK FOOTER //
// src/components/Settings/Showcase.vue